var Carousels;
(function (Carousels) {
    const carousels = document.querySelectorAll('.product-showcase-carousel');
    if (carousels.length) {
        carousels.forEach(carousel => {
            let currentIndex = 0;
            const slide = carousel.querySelectorAll('.container-info');
            const nextButton = document.querySelector('.button-right');
            const prevButton = document.querySelector('.button-left');
            const setInfoSlide = newIndex => {
                currentIndex = newIndex;
                const slideItems = carousel.querySelectorAll('.container-info');
                const activeSlideItems = carousel.querySelector('.container-info.slide-active');
                changeClassesToCarousel(slideItems, activeSlideItems, currentIndex, 'slide-active');
                const slidesText = carousel.querySelectorAll('.slide-text');
                const activeSlidesText = carousel.querySelector('.slide-text.active');
                changeClassesToCarousel(slidesText, activeSlidesText, currentIndex, 'active');
                const slideImages = carousel.querySelectorAll('.slide-image');
                const activeSlideImage = carousel.querySelector('.slide-image.active');
                changeClassesToCarousel(slideImages, activeSlideImage, currentIndex, 'active');
            };
            const changeClassesToCarousel = (elementsList, elementToToggle, currentIndex, classToChange) => {
                elementToToggle.classList.remove(classToChange);
                if (elementsList && elementsList[currentIndex]) {
                    elementsList[currentIndex].classList.add(classToChange);
                }
            };
            const prevSlide = () => {
                currentIndex = (currentIndex - 1) % slide.length;
                if (currentIndex == -1) {
                    currentIndex = slide.length - 1;
                }
                setInfoSlide(currentIndex);
            };
            const nextSlide = () => {
                setInfoSlide((currentIndex + 1) % slide.length);
            };
            if (nextButton) {
                nextButton.addEventListener('click', () => {
                    nextSlide();
                });
            }
            if (prevButton) {
                prevButton.addEventListener('click', () => {
                    prevSlide();
                });
            }
        });
    }
})(Carousels || (Carousels = {}));
